import { FormEnginePlugin } from '@form-engine/core-application';
import Element, { apiName } from './components/select-element';

declare module '@form-engine/core-application/types/form' {
    interface ElementDefinitionSubType {
        [apiName]: ElementDefinitionBoundsProps &
            ElementDefinitionFieldProps &
            ElementDefinitionDatasourceProps &
            ElementDefinitionValidationProps & {
                showDefaultOption?: boolean;
                defaultOptionLabel?: string;
                controlType?: string;
                searchable?: boolean;
                placeholder?: string;
            };
    }
}

export default {
    elements: {
        [Element.apiName]: Element,
    },
} as FormEnginePlugin;
